import React from 'react';
export var RadioField = function RadioField(props) {
  return props.visible && /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("legend", null, props.label), props.options.map(function (option) {
    return /*#__PURE__*/React.createElement("label", {
      key: option.get('value')
    }, /*#__PURE__*/React.createElement("input", {
      name: props.name,
      type: "radio",
      value: option.get('value'),
      checked: props.value === option.get('value'),
      onChange: props.onChange,
      onBlur: props.onBlur,
      onFocus: props.onFocus
    }), option.get('label'));
  }));
};